"use strict";

exports.__esModule = true;
var ON_SIMPLE_VALUE_CHANGED = exports.ON_SIMPLE_VALUE_CHANGED = "dialogs@ON_SIMPLE_VALUE_CHANGED";


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/store/simpleValues/types.js
// module id = 423
// module chunks = 49